import { z } from 'zod'
import QuestionWrapper from '../../questionnaire/formSteps/QuestionWrapper'

export const homeInfo = {
  component: QuestionWrapper,
  componentProps: {
    title: 'Please share details about your home',
    label: 'Address',
    tooltip:
      'Your home details give us a more accurate understanding of your energy usage and what plans will fit your home best.',
    tracking: {
      stepName: 'Home Details',
      deepStepNumber: 1,
      quickStepNumber: 1,
      deepStepId: '1.1',
      quickStepId: '1.1',
    },
  },
  name: 'homeInfo',
  coreIf: false, // Not core - supplementary home details
  schema: z.object({
    'homeInfo.homeSize': z.string().min(1, 'Home size is required.'),
    'homeInfo.numBedrooms': z.string().min(1, 'Number of bedrooms is required.'),
    'homeInfo.numBathrooms': z.string().min(1, 'Number of bathrooms is required.'),
    'homeInfo.numFloors': z.string().min(1, 'Number of floors is required.'),
    'homeInfo.yearBuilt': z.string().min(1, 'Year built is required.'),
  }),
  visibleIf: {
    formStepKey: 'address.enriched',
    comparisonOperator: '===' as const,
    expectedAnswer: false,
  },
}
